import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { FlexBox, Fonts, NavBarLinks, useIsMobile } from '@brg/ui';
import { AGEYTOMESH_LOGO_LENGTH } from 'shared/constants/misc';
import { useSelector } from "react-redux";
import { AppTester } from "../../../../../../supporting";
import { useRouteMatch } from "react-router-dom";
import { LinkTo } from "../../../../../constants/linkTo";
import { LayoutConst } from 'core';
import { NeutralLink } from "../../../../link/styles";


export interface NavBarLink {
  active?: boolean;
  action?: (e: React.MouseEvent<HTMLDivElement>) => void;
  content: JSX.Element | string;
  disabled?: boolean;
  hidden?: boolean;
  linkTo?: string;
  isModal?: boolean;
}

export interface NavBarLinksWidgetTheming {
  color: string;
  hoverColor: string;
  activeColor: string;
}

export const NavBarLinksWidgetItemLine = styled.div`
  background: ${(p) => p.theme.navigationBar.linksWidgetLineGradient};
  height: 1px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`;

export const NavBarLinksWidgetItem = styled(FlexBox)<{ active?: boolean; disabled?: boolean, hidden?: boolean } & NavBarLinksWidgetTheming>`
  // ${Fonts.Inter.smallTextBold};
  cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};
  font-family: 'Inter';
  opacity: ${(p) => (p.disabled ? 0.3 : 1)};
  display: ${(p) => (p.hidden ? 'none' : 'flex')};
  transition: all 0.2s;
  position: relative;
  font-weight: 600;
  align-items: center;
  font-size: ${({ theme }) => theme.navigationBar.font.l.fontSize};
  line-height: ${({ theme }) => theme.navigationBar.font.l.lineHeight};
  letter-spacing: -0.02em;
  color: ${(p: NavBarLinksWidgetTheming) => p.color};

  & + & {
    margin-left: 24px;
  }

  @media(max-width: ${LayoutConst.screen.l_16}px) {
    font-size: ${({ theme }) => theme.navigationBar.font.m.fontSize};
    line-height: ${({ theme }) => theme.navigationBar.font.m.lineHeight};
    font-weight: 600;

    & + & {
      margin-left: 16px;
    }
  }

  @media(max-width: ${LayoutConst.screen.mac13}px) {
    & + & {
      margin-left: 16px;
    }
  }

  // @media (max-width: ${LayoutConst.screen.md}px) {
  //   font-size: 13px;
  // }

  ${NavBarLinksWidgetItemLine} {
    height: 1px;
    background: none;
  }

  &:hover {
    color: ${(p: NavBarLinksWidgetTheming) => p.hoverColor};

    ${NavBarLinksWidgetItemLine} {
      height: 2px;
      background: ${(p) => p.theme.navigationBar.linksWidgetLineGradient};
    }
  }

  &:active {
    color: ${(p: NavBarLinksWidgetTheming) => p.activeColor};

    ${NavBarLinksWidgetItemLine} {
      height: 1px;
      background: ${(p) => p.theme.navigationBar.linksWidgetLineGradient};
    }
  }

  ${(p: NavBarLinksWidgetTheming & { active?: boolean }) =>
          p.active
                  ? css`
                    color: ${(p: NavBarLinksWidgetTheming) => p.activeColor};

                    ${NavBarLinksWidgetItemLine} {
                      height: 2px !important;
                      background: ${(p) => p.theme.navigationBar.linksWidgetLine};
                    }
                  `
                  : null};

`;

const StyledLink = styled(NeutralLink)`
  height: 100%;
  display: flex;
  align-items: center;
`

export const NavBarLinksWidgetItems = styled(FlexBox)<{ shifted?: boolean, offset?: boolean }>`
  height: 64px;
  position: relative;
  left: ${({ shifted }) => shifted ? `-${AGEYTOMESH_LOGO_LENGTH}px` : 0};
  transition: all 500ms;
  @media (max-width: ${LayoutConst.screen.l_16}px) {
    height: 48px;
    min-height: 48px;
    ${({ offset }) => offset ? css`
      padding-top: 3px;
    ` : null};
  }
`;

export interface NavBarLinksWidgetProps {
  items: NavBarLink[];
  theming: NavBarLinksWidgetTheming;
}

export const NavBarLinksWidget: FC<NavBarLinksWidgetProps> = ({ items, theming }) => {
  const logoShifted = useSelector((state: any) => state.animations.logoShifted);
  const isAgeytomesh = AppTester.isAgeytomesh();
  const isProjectPage = useRouteMatch(LinkTo.project);
  const isMobile = useIsMobile();

  return (
      // @ts-ignore
      <NavBarLinks items={items} theming={theming} isShifted={isAgeytomesh && logoShifted && !isMobile && !isProjectPage}></NavBarLinks>
  );
}
import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { FlexBox, Fonts, NavBarLinks, useIsMobile } from '@brg/ui';
import { AGEYTOMESH_LOGO_LENGTH } from 'shared/constants/misc';
import { useSelector } from "react-redux";
import { AppTester } from "../../../../../../supporting";
import { useRouteMatch } from "react-router-dom";
import { LinkTo } from "../../../../../constants/linkTo";
import { LayoutConst } from 'core';
import { NeutralLink } from "../../../../link/styles";


export interface NavBarLink {
  active?: boolean;
  action?: (e: React.MouseEvent<HTMLDivElement>) => void;
  content: JSX.Element | string;
  disabled?: boolean;
  hidden?: boolean;
  linkTo?: string;
  isModal?: boolean;
}

export interface NavBarLinksWidgetTheming {
  color: string;
  hoverColor: string;
  activeColor: string;
}

export const NavBarLinksWidgetItemLine = styled.div`
  background: ${(p) => p.theme.navigationBar.linksWidgetLineGradient};
  height: 1px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`;

export const NavBarLinksWidgetItem = styled(FlexBox)<{ active?: boolean; disabled?: boolean, hidden?: boolean } & NavBarLinksWidgetTheming>`
  // ${Fonts.Inter.smallTextBold};
  cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};
  font-family: 'Inter';
  opacity: ${(p) => (p.disabled ? 0.3 : 1)};
  display: ${(p) => (p.hidden ? 'none' : 'flex')};
  transition: all 0.2s;
  position: relative;
  font-weight: 600;
  align-items: center;
  font-size: ${({ theme }) => theme.navigationBar.font.l.fontSize};
  line-height: ${({ theme }) => theme.navigationBar.font.l.lineHeight};
  letter-spacing: -0.02em;
  color: ${(p: NavBarLinksWidgetTheming) => p.color};

  & + & {
    margin-left: 24px;
  }

  @media(max-width: ${LayoutConst.screen.l_16}px) {
    font-size: ${({ theme }) => theme.navigationBar.font.m.fontSize};
    line-height: ${({ theme }) => theme.navigationBar.font.m.lineHeight};
    font-weight: 600;

    & + & {
      margin-left: 16px;
    }
  }

  @media(max-width: ${LayoutConst.screen.mac13}px) {
    & + & {
      margin-left: 16px;
    }
  }

  // @media (max-width: ${LayoutConst.screen.md}px) {
  //   font-size: 13px;
  // }

  ${NavBarLinksWidgetItemLine} {
    height: 1px;
    background: none;
  }

  &:hover {
    color: ${(p: NavBarLinksWidgetTheming) => p.hoverColor};

    ${NavBarLinksWidgetItemLine} {
      height: 2px;
      background: ${(p) => p.theme.navigationBar.linksWidgetLineGradient};
    }
  }

  &:active {
    color: ${(p: NavBarLinksWidgetTheming) => p.activeColor};

    ${NavBarLinksWidgetItemLine} {
      height: 1px;
      background: ${(p) => p.theme.navigationBar.linksWidgetLineGradient};
    }
  }

  ${(p: NavBarLinksWidgetTheming & { active?: boolean }) =>
          p.active
                  ? css`
                    color: ${(p: NavBarLinksWidgetTheming) => p.activeColor};

                    ${NavBarLinksWidgetItemLine} {
                      height: 2px !important;
                      background: ${(p) => p.theme.navigationBar.linksWidgetLine};
                    }
                  `
                  : null};

`;

const StyledLink = styled(NeutralLink)`
  height: 100%;
  display: flex;
  align-items: center;
`

export const NavBarLinksWidgetItems = styled(FlexBox)<{ shifted?: boolean, offset?: boolean }>`
  height: 64px;
  position: relative;
  left: ${({ shifted }) => shifted ? `-${AGEYTOMESH_LOGO_LENGTH}px` : 0};
  transition: all 500ms;
  @media (max-width: ${LayoutConst.screen.l_16}px) {
    height: 48px;
    min-height: 48px;
    ${({ offset }) => offset ? css`
      padding-top: 3px;
    ` : null};
  }
`;

export interface NavBarLinksWidgetProps {
  items: NavBarLink[];
  theming: NavBarLinksWidgetTheming;
}

export const NavBarLinksWidget: FC<NavBarLinksWidgetProps> = ({ items, theming }) => {
  const logoShifted = useSelector((state: any) => state.animations.logoShifted);
  const isAgeytomesh = AppTester.isAgeytomesh();
  const isProjectPage = useRouteMatch(LinkTo.project);
  const isMobile = useIsMobile();

  return (
      // @ts-ignore
      <NavBarLinks items={items} theming={theming} isShifted={isAgeytomesh && logoShifted && !isMobile && !isProjectPage}></NavBarLinks>
  );
}
